export enum OrderConcealStrategy {
  Combine,
  ShowAll
}
